import {Component, OnInit} from '@angular/core';
import {LoginService} from '../login/login.service';
import {Router, ActivatedRoute, Params, ROUTER_DIRECTIVES} from '@angular/router';

declare var $: any;

@Component({
    selector: 'reset',
    template: require('../../app/reset/reset.component.html'),
    styles: [require('../../app/reset/reset.component.css')],
    directives: [ROUTER_DIRECTIVES]
})

export class ResetComponent implements OnInit {
    password = "";
    repetirPassword = "";
    error = "";
    token = "";

    constructor(private loginService: LoginService, private router: Router, private activatedRoute: ActivatedRoute) {
        loginService.error.subscribe((error) => this.error = error);
    }

    ngOnInit() {
        this.activatedRoute.params.subscribe((params: Params) => {
            this.token = params['token'];
            console.log(this.token);
            this.loginService.validateReset(this.token);
        });

        //Detectar ojo pass
        $("#ojo").mousedown(function () {
            $(".noVisible").css("display", "none");
            $(".visible").css("display", "inline");
        });
        $("#ojo").mouseup(function () {
            $(".noVisible").css("display", "inline");
            $(".visible").css("display", "none");
        });
    }

    cambiarRepetirPassword() {
        let input = $("#repetirPassword");
        if (this.password != this.repetirPassword)
            $("#repetirPassword").get(0).setCustomValidity("Las contraseñas deben coincidir");
        else
            $("#repetirPassword").get(0).setCustomValidity("");
    }

    resetPassword(e) {
        //e.preventDefault();
        if($("#formulario")[0].checkValidity())
        this.loginService.resetPassword(this.token, this.password);
    }


}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/reset/reset.component.ts